import { NgModule } from '@angular/core';
import { VerticalAlignerComponent } from './vertical-aligner.component';
import { CommonModule } from '@angular/common';
import { MobileCentralDisplayComponent } from './mobile-central-display/mobile-central-display.component';

@NgModule({
  declarations: [
    VerticalAlignerComponent,
    MobileCentralDisplayComponent
  ],
  imports: [CommonModule],
  exports: [
    VerticalAlignerComponent,
    MobileCentralDisplayComponent
  ]
})
export class VerticalAlignerModule {}
